import { SearchFieldComponent } from './search-field.component';

export default angular
  .module('sfMobile.components.search-field', [
    'sfMobile.services.modal',
    'pascalprecht.translate',
  ])
  .component('sfSearchField', SearchFieldComponent).name;
